import React, { useEffect, useState } from 'react';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    TextField,
    TablePagination,
} from '@mui/material';
import Link from "next/link";

function MainTable({ data, search, tableColumns, customButton , PerPage = 5 }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(PerPage);
    const [searchTerm, setSearchTerm] = useState('');

    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        setLoaded(true);
    }, []);

    const filteredData = data?.filter((row) =>
        search.some((field) =>
            row[field]?.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        loaded && (
            <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto">
                <div>
                    <div className="flex justify-end mb-3">
                        <TextField
                            label="Search"
                            variant="outlined"
                            value={searchTerm}
                            className="mb-4 shadow-md bg-white"
                            size="small"
                            type='search'
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead className="bg-[#f1f1f1]">
                                <TableRow>
                                    <TableCell className='font-semibold' >
                                        ID
                                    </TableCell>
                                    {tableColumns?.map((data, index) => (
                                        <TableCell className='font-semibold' key={index}>
                                            {data.header}
                                        </TableCell>
                                    ))}
                                    <TableCell className='font-semibold' >
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => (
                                        <TableRow key={index} className="hover:bg-slate-100">
                                            <TableCell key={index}>{filteredData?.length - ((filteredData.length / rowsPerPage) - page) * rowsPerPage + index+1}</TableCell>
                                            {tableColumns?.map((data, index) => (
                                                <TableCell key={index}>{row[data.field]}</TableCell>
                                            ))}
                                            <TableCell>
                                                {
                                                    customButton ? customButton(row.full_slug ? row.full_slug : row.slug) : null
                                                }

                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25 , 50 , 100 , 500 ]}
                        component="div"
                        count={filteredData?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </div>
            </div>
        )
    );
}

export default MainTable;
